import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { DateTime } from 'ts-luxon'
import type { CabinetFilter } from './types'
import { useHelpers, useTranslate } from '@/shared/lib'

const useCabinetReports = defineStore('cabinet_reports', () => {
  const dateFormat: string = "yyyy-LL-dd'T'HH:mm"
  const { monthsList } = useHelpers()
  const { trs } = useTranslate()

  /* Данные фильтра */
  const filter = ref<CabinetFilter>({
    date_from: DateTime.now().startOf('day').toFormat(dateFormat),
    date_to: '',
    year_first: 0,
    year_last: 0,
    month_first: 0,
    month_last: 0,
    interval: 5,
    phase_a: true,
    phase_b: true,
    phase_c: true,
    page: 1,
    per_page: 10,
    meter: -1,
  })

  const perPageList = [10, 50, 100]

  const callback = ref<Function | null>(null)
  const metersCount = ref<number>(1)
  const contentType = 'table'

  /* Временные рамки для сравнения */
  const timeCompare = {
    first: [
      {
        value: 0,
        title: trs('itf.basic'),
        months: [{ value: 0, title: trs('itf.all_year') }, ...monthsList()],
      },
    ],
    last: [
      {
        value: 0,
        title: trs('itf.basic'),
        months: [{ value: 0, title: trs('itf.all_year') }, ...monthsList()],
      },
    ],
  }

  /** Отслеживаем изменение счетчика и вызываем функцию */
  watch(
    () => filter.value.meter,
    () => {
      if (callback.value) callback.value()
    },
  )

  /**
   * Функции установки функции обработки
   * @param value
   */
  const setCallback = (value: Function) => {
    callback.value = value
  }

  return {
    filter,
    callback,
    metersCount,
    contentType,
    perPageList,
    dateFormat,
    timeCompare,

    setCallback,
  }
})

export { useCabinetReports }
